export const isEmptyObj = (obj: Object): boolean => {
    for (var key in obj) {
        if (obj.hasOwnProperty(key))
            return false;
    }
    return true;
}